import { useEffect, useRef, useState } from "react";
import { navigation } from "@/content/homepage";

export default function HomeNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef(null);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        menuButtonRef.current?.focus();
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [menuOpen]);

  return (
    <header className="av-header" data-testid="nav">
      <div className="av-shell av-nav-shell">
        <a className="av-wordmark-link" href="/" aria-label="Averentia — Home">
          <img
            className="av-wordmark"
            src="/brand/averentia-wordmark.png"
            alt=""
            data-testid="nav-logo-image"
          />
        </a>

        <nav className="av-primary-nav" aria-label="Primary navigation">
          {navigation.map((item) => (
            <a key={item.label} href={item.href}>
              {item.label}
            </a>
          ))}
          <a className="av-nav-contact" href="/contact">
            Contact
          </a>
        </nav>

        <button
          ref={menuButtonRef}
          className="av-menu-button"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          aria-controls="av-mobile-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
        </button>
      </div>

      {menuOpen && (
        <nav
          id="av-mobile-navigation"
          className="av-mobile-nav is-open"
          aria-label="Mobile navigation"
        >
          {navigation.map((item) => (
            <a key={item.label} href={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          ))}
          <a href="/contact" onClick={closeMenu}>
            Contact
          </a>
        </nav>
      )}
    </header>
  );
}
